import React, { useState, useEffect } from "react";
import Navbar from "../../home/Navbar";
import Queryform from "../Queryform";
import Footer from "../../home/Footer";
import { useNavigate } from "react-router";
import { API_END_POINT } from "../Utils/Constant";
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import Loader from "../Loader";

const HoraPanchang = () => {
  const [data, setData] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const navigate = useNavigate();

  // Fetch Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_END_POINT}panchang/horamuhurtapanchang`);
        const result = await response.json();
        if (result.status === 200) {
          setData(result.response);
        }
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchData();
  }, []);

  if (!data) {
    return <div className="flex justify-center items-center h-screen"><Loader/></div>;
  }

  const cards = [
    { title: "Chaughadiya", subtitle: "Muhurata", path: "/chaughadiya/panchang" },
    { title: "Hora", subtitle: "Muhurata", path: "/hora/panchang" },
    { title: "Daily", subtitle: "Panchang", path: "/daily/panchang" },
  ];

  return (
    <>
      <section className="bg-gradient-to-r from-white to-success/40 text-gray-900 min-h-screen">
        <Navbar />

        {/* Header Section */}
        <div className="flex flex-col items-center mt-10 text-center px-4">
          <h1 className="text-3xl font-serif text-secondary uppercase font-bold">Hora Panchang</h1>
          <div className="w-11/12 lg:w-4/5 md:w-4/5 sm:w-11/12  flex items-center justify-center bg-gradient-to-r from-success to-[#9034E9] p-4 mt-5 rounded-lg shadow-md">
            <h2 className="text-white font-sans text-xl sm:text-2xl font-bold text-center">
              Hora Panchang For {selectedDate.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
            </h2>
          </div>
        </div>

        {/* Hora Panchang Table */}
        <div className="w-11/12 lg:w-4/5 md:w-4/5 sm:w-11/12  bg-white shadow-lg mx-auto mt-8 p-4 rounded-lg overflow-x-auto">
          <Table className="w-full border-collapse border-4 border-secondary table-auto text-sm sm:text-base">
            <Thead>
              <Tr className="bg-gradient-to-r from-success to-[#9034E9] text-white">
                <Th className="border-4 border-secondary px-2 py-2">Start</Th>
                <Th className="border-4 border-secondary px-2 py-2">End</Th>
                <Th className="border-4 border-secondary px-2 py-2">Hora</Th>
                <Th className="border-4 border-secondary px-2 py-2">Benefits</Th>
                <Th className="border-4 border-secondary px-2 py-2">Lucky Gem</Th>
              </Tr>
            </Thead>
            <Tbody>
              {data.horas.map((item, index) => (
                <Tr key={index} className="text-center bg-gray-50 even:bg-gray-100">
                  <Td className="border-2 border-secondary px-2 py-2">{new Date(item.start).toLocaleTimeString()}</Td>
                  <Td className="border-2 border-secondary px-2 py-2">{new Date(item.end).toLocaleTimeString()}</Td>
                  <Td className="border-2 border-secondary px-2 py-2 font-bold">{item.hora}</Td>
                  <Td className="border-2 border-secondary px-2 py-2">{item.benefits}</Td>
                  <Td className="border-2 border-secondary px-2 py-2">{item.lucky_gem}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </div>

        {/* Navigation Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 w-11/12 sm:w-3/4 mx-auto mt-10">
          {cards.map((card, index) => (
            <div
              key={index}
              onClick={() => navigate(card.path)}
              className="bg-gradient-to-br from-blue-500 to-purple-400 text-white text-center font-bold text-lg sm:text-xl p-6 sm:p-8 rounded-lg shadow-lg cursor-pointer transform transition-transform hover:scale-105"
            >
              <h2>{card.title}</h2>
              <p>{card.subtitle}</p>
            </div>
          ))}
        </div>

        <Queryform />
        <Footer />
      </section>
    </>
  );
};

export default HoraPanchang;
